import http from "../axios/http-common";

class InterfaceRujukan {
  getRujukanByReg(reg) {
    return http.getData(`/register/${reg}/surat-rujukan`);
  }
  getRujukanById(id) {
    return http.getData(`/surat-rujukan/${id}`);
  }
  saveRujukan(
    tujuan_id,
    unit_tujuan_text,
    dokter_id,
    unit_id,
    register_id,
    pasien_rm,
    diagnosis,
    alasan,
    kondisi,
    terapi_diberikan,
    penunjang,
    terapi_diharapkan
  ) {
    return http.postData(`/surat-rujukan`, {
      tujuan_id: tujuan_id,
      unit_tujuan_text: unit_tujuan_text,
      dokter_id: dokter_id,
      unit_id: unit_id,
      register_id: register_id,
      pasien_rm: pasien_rm,
      diagnosis: diagnosis,
      alasan: alasan,
      kondisi: kondisi,
      terapi_diberikan: terapi_diberikan,
      penunjang: penunjang,
      terapi_diharapkan: terapi_diharapkan
    });
  }
  editRujukan(
    id,
    tujuan_id,
    unit_tujuan_text,
    dokter_id,
    unit_id,
    register_id,
    pasien_rm,
    diagnosis,
    alasan,
    kondisi,
    terapi_diberikan,
    penunjang,
    terapi_diharapkan
  ) {
    return http.putData(`/surat-rujukan/${id}`, {
      tujuan_id: tujuan_id,
      unit_tujuan_text: unit_tujuan_text,
      dokter_id: dokter_id,
      unit_id: unit_id,
      register_id: register_id,
      pasien_rm: pasien_rm,
      diagnosis: diagnosis,
      alasan: alasan,
      kondisi: kondisi,
      terapi_diberikan: terapi_diberikan,
      penunjang: penunjang,
      terapi_diharapkan: terapi_diharapkan
    });
  }
  saveTtdRujukan(reg, user_id, password) {
    return http.postData(`/register/${reg}/surat-rujukan/signature`, {
      dokter_id: user_id,
      password: password
    });
  }


  getJawabanRujukanByReg(reg) {
    return http.getData(`/register/${reg}/surat-jawaban-rujukan`);
  }

  getJawabanRujukanById(id) {
    return http.getData(`/surat-jawaban-rujukan/${id}`);
  }

  saveJawabanRujukan(
    tgl_surat,
    register_id,
    pasien_rm,
    dokter_id,
    dokter_tujuan,
    faskes_tujuan_id,
    faskes_tujuan_nama,
    diagnosis,
    terapi,
    saran
  ) {
    return http.postData(`/surat-jawaban-rujukan`, {
      tgl_surat: tgl_surat,
      register_id: register_id,
      pasien_rm: pasien_rm,
      dokter_id: dokter_id,
      dokter_tujuan: dokter_tujuan,
      faskes_tujuan_id: faskes_tujuan_id,
      faskes_tujuan_nama: faskes_tujuan_nama,
      diagnosis: diagnosis,
      terapi: terapi,
      saran: saran
    });
  }

  editJawabanRujukan(
    id,
    tgl_surat,
    register_id,
    pasien_rm,
    dokter_id,
    dokter_tujuan_nama,
    faskes_tujuan_id,
    faskes_tujuan_nama,
    diagnosis,
    terapi,
    saran
  ) {
    return http.putData(`/surat-jawaban-rujukan/${id}`, {
      id,
      tgl_surat: tgl_surat,
      register_id: register_id,
      pasien_rm: pasien_rm,
      dokter_id: dokter_id,
      dokter_tujuan_nama: dokter_tujuan_nama,
      faskes_tujuan_id: faskes_tujuan_id,
      faskes_tujuan_nama: faskes_tujuan_nama,
      diagnosis: diagnosis,
      terapi: terapi,
      saran: saran
    });
  }

  saveTtdJawabanRujukan(reg, user_id, password) {
    return http.postData(`/register/${reg}/surat-jawaban-rujukan/signature`, {
      dokter_id: user_id,
      password: password
    });
  }
  // saveTtdJawabanRujukan(id, user_id, password) {
  //   // return http.postData(`/surat-jawaban-rujukan/${id}/signature`, {
  //   return http.postData(`/surat-jawaban-rujukan/${id}/signature`, {
  //     user_id: user_id,
  //     password: password
  //   });
  // }

  getFaskesCustom(term) {
    return http.getDataParam(`/referensi/faskes-custom`, {
      params: {
        term: term
      }
    })
  }

}

export default new InterfaceRujukan();
